module.exports = __webpack_public_path__ + "static/media/top.aa55c003.jpg";